import React from 'react';
import PropTypes from 'prop-types';
import min from 'lodash/min';
import { Box, Text } from 'roo-ui/components';

const Summary = ({ from, to, total }) => {
  const lastResult = min([to, total]);
  return (
    <Box py={1}>
      <Text mr={1}>Showing</Text>
      <Text data-testid="from-result">{from}</Text> - <Text data-testid="to-result">{lastResult}</Text>
      <Text> of </Text>
      <Text data-testid="total-results">{total}</Text>
      <Text ml={1}>properties</Text>
    </Box>
  );
};

Summary.propTypes = {
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default Summary;
